/**
 * SubscriptionContentSetsCtrl controller
 */
import {
  CONTENT_SET_TYPES,
  CONTENT_TYPES_SETS_SHORT, PAYMENT_SYSTEM_TYPES,
  REPORT_DISPLAY_MODE_TYPES,
  SET_PRICING_MONETIZATION_TYPES_LABELS,
  SET_PRICING_PAYMENT_METHOD_TYPES,
  SET_PRICING_PAYMENT_METHOD_TYPES_LABELS,
  SET_PRICING_POLICY_TEXT_TYPES,
  SET_SETTINGS_TYPES,
  SHOWSET_TYPE_LABELS,
  SUBSCRIPTION_PRODUCT_TYPES_FOR_DISCOUNT
} from 'app/core/constants'
import { isTvDip, isSectionInvalid } from '../../app/helpers/fn'
import { dateAsUTC } from '../../app/helpers/date'

// controller mixins
SubscriptionContentSetsCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * SubscriptionContentSetsCtrl controller
 *
 * @class SubscriptionContentSetsCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:SubscriptionContentSetsCtrl
 */
/* @ngInject */
export default function SubscriptionContentSetsCtrl (
  $scope,
  $uibModal,
  ChannelSet,
  LiveEventSet,
  ShowSet,
  Subscription,
  VODSet,
  authSvc,
  pckg,
  scope,
  subscription
) {
  var vm = this
  vm.FEATURE_RADIO_CHANNELS_ENABLED = authSvc.hasEnabledFlag('FEATURE_RADIO_CHANNELS_ENABLED')
  vm.FEATURE_EXCLUSIVE_PAYMENT_METHODS_ENABLED = authSvc.hasEnabledFlag('FEATURE_EXCLUSIVE_PAYMENT_METHODS_ENABLED')

  vm.payment_system_types_array = Object.keys(PAYMENT_SYSTEM_TYPES)
  vm.payment_system_types = PAYMENT_SYSTEM_TYPES
  vm.set_settings_types = SET_SETTINGS_TYPES
  vm.set_pricing_payment_method_types_labels = SET_PRICING_PAYMENT_METHOD_TYPES_LABELS
  vm.showset_type_labels = SHOWSET_TYPE_LABELS
  vm.content_types_sets = CONTENT_TYPES_SETS_SHORT

  /**
   * Package/Network
   *
   * @memberof mwApp/packages.controller:SubscriptionContentSetsCtrl
   * @type {models.Network}
   */
  vm.pckg = pckg

  vm.notTvDip = !isTvDip()

  /**
   * Subscription
   *
   * @memberof mwApp/packages.controller:SubscriptionContentSetsCtrl
   * @type {models.Subscription}
   */
  vm.subscription = subscription

  /**
   * Currency of subscription
   *
   * @memberof mwApp/packages.controller:SubscriptionContentSetsCtrl
   * @type {models.Currency}
   */
  vm.currency = vm.subscription.currency

  /**
   * Vod Set Pricing payment method labels
   *
   * @memberof mwApp/packages.controller:ContentSetsCtrl
   * @type {Object}
   */
  vm.set_pricing_payment_method_labels = SET_PRICING_PAYMENT_METHOD_TYPES_LABELS

  /**
   * Vod Set Pricing payment method types
   *
   * @memberof mwApp/packages.controller:ContentSetsCtrl
   * @type {Object}
   */
  vm.set_pricing_payment_method_types = SET_PRICING_PAYMENT_METHOD_TYPES

  /**
   * Display period types
   *
   * @memberof mwApp/packages.controller:ContentSetsCtrl
   * @type {Object}
   */
  vm.report_display_mode_types = REPORT_DISPLAY_MODE_TYPES

  /**
   * Display Monetization types
   *
   * @memberof mwApp/packages.controller:ContentSetsCtrl
   * @type {Object}
   */
  vm.set_pricing_monetization_types = SET_PRICING_MONETIZATION_TYPES_LABELS

  /**
   * Display Policy types
   *
   * @memberof mwApp/packages.controller:ContentSetsCtrl
   * @type {Object}
   */
  vm.set_pricing_policy_types = SET_PRICING_POLICY_TEXT_TYPES

  /**
   * Check for tv show and seasons set
   * @type {Boolean}
   */
  vm.showSetEnabled = true

  vm.discountsProductTypes = SUBSCRIPTION_PRODUCT_TYPES_FOR_DISCOUNT

  // load extra for vod set settings
  /* VODSetSetting.loadExtra({ networkId, subscriptionId })
    .to(vm) */

  vm.makeMessageForDeletingContentSet = function (type, item) {
    const assignedInRules = vm.subscription._countDiscountRulesForSubscriptionProduct('CONTENT_ADDON', item)

    const messagePart0 = `Content Add-on ${item.name} is used in `
    const messagePart1 = assignedInRules
      .map((rule) =>
      `Pricing Rule ${rule.ruleIndex + 1} for ${vm.discountsProductTypes[type]} ${vm.subscription._getDiscountProductProperty(rule.conditionProductType, rule, 'name') || ''}`)
      .join(', ')
    const messagePart2 = `. Please pay attention that if you delete this ${vm.discountsProductTypes[type]}, pricing rules may be changed or deleted. <br><br>`
    return assignedInRules.length ? messagePart0 + messagePart1 + messagePart2 : ''
  }

  /**
   * Delete Paid Content Setset
   *
   * @memberof mwApp/packages.controller:SubscriptionContentSetsCtrl
   * @param {String} type
   * @param {Number} setId
   */
  vm.deletePaidContentSet = function (type, setId) {
    vm.subscription.paidContentSets[type] = vm.subscription.paidContentSets[type].filter(set => set.id !== setId)
    vm.checkIntersection(type, true)
    vm.validateContentSetsQuantity()
  }

  /**
   * Delete Free Content Setset
   *
   * @memberof mwApp/packages.controller:SubscriptionContentSetsCtrl
   * @param {String} type
   * @param {Number} setId
   */
  vm.deleteBasicContentSet = function (type, setId) {
    vm.subscription.freeContentSets[type] = vm.subscription.freeContentSets[type].filter(s => s.id !== setId)
    vm.checkIntersection(type, true)
    vm.validateContentSetsQuantity()
  }

  vm.intersections = {}

  vm.subscription.$intersections = vm.intersections

  vm.checkIntersection = function (type, checkOnDelete = false) {
    if (checkOnDelete && !vm.intersections[type]) { return Promise.resolve(false) }

    const assignedBasicSets = vm.subscription?.freeContentSets[type] || []
    const assignedPaidSets = vm.subscription?.paidContentSets[type] || []

    return Subscription.checkIntersection(type, { networkId: pckg.id, id: subscription.id || 0 }, assignedBasicSets, assignedPaidSets)
      .then((data) => {
        vm.intersections[type] = data
      })
  }

  /**
   * Create/Update pricing
   *
   * @memberof mwApp/packages.controller:SubscriptionContentSetsCtrl
   * @function
   * @param {String} type
   */
  vm.addFreeContentSets = function (type) {
    if (!vm.subscription.freeContentSets || (vm.subscription.freeContentSets && !vm.subscription.freeContentSets[type])) {
      vm.subscription.freeContentSets = { ...vm.subscription.freeContentSets, [type]: [] }
    }
    const initialSets = angular.copy(vm.subscription.freeContentSets ? vm.subscription.freeContentSets[type] : [])
    $uibModal.open({
      templateUrl: 'components/packages/views/addContentSets.html',
      controller: 'AddContentSetsCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        networkId: function () {
          return pckg.id
        },
        type: function () {
          return type
        },
        assignedSets: function () {
          return vm.subscription.freeContentSets ? vm.subscription.freeContentSets[type] : []
        },
        addons: function () {
          return vm.subscription.paidContentSets ? vm.subscription.paidContentSets[type] : []
        },
        subscription: function () {
          return vm.subscription
        },
        hasCSintersection: function () {
          return vm.intersections[type]
        }
      }
    }).result
      .then(
        function close (sets) {
          vm.subscription.freeContentSets[type] = angular.copy(sets)
          vm.validateContentSetsQuantity()
        },
        function dismiss () {
          angular.copy(initialSets, vm.subscription.freeContentSets[type]) // restore pricing
          vm.checkIntersection(type)
        })
  }

  /**
   * Create/Update pricing
   *
   * @memberof mwApp/packages.controller:SubscriptionContentSetsCtrl
   * @function
   * @param {String} type
   */
  vm.addAddons = function (type) {
    if (!vm.subscription.paidContentSets || (vm.subscription.paidContentSets && !vm.subscription.paidContentSets[type])) {
      vm.subscription.paidContentSets = { ...vm.subscription.paidContentSets, [type]: [] }
    }
    const initialSets = angular.copy(vm.subscription.paidContentSets ? vm.subscription.paidContentSets[type] : [])
    $uibModal.open({
      templateUrl: 'components/packages/views/addAddons.html',
      controller: 'AddAddonsCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        networkId: function () {
          return pckg.id
        },
        type: function () {
          return type
        },
        assignedAddons: function () {
          return vm.subscription.paidContentSets ? vm.subscription.paidContentSets[type] : []
        },
        assignedBasicSets: function () {
          return vm.subscription.freeContentSets ? (vm.subscription.freeContentSets[type] || []) : []
        },
        subscription: function () {
          return vm.subscription
        }
      }
    }).result
      .then(
        function close (sets) {
          if (['channelSets', 'multiSets'].includes(type)) {
            sets.forEach(set => {
              if (!vm.subscription.paidContentSets[type].find(s => s.id === set.id)) {
                set.pricing.rent.$periodType = vm.subscription.$periodType
                if (vm.subscription.$periodType === 'DUE_DATE') {
                  set.pricing.rent.dueDate = vm.subscription.dueDate
                  set.pricing.rent.$dueDate = vm.subscription.$dueDate
                  set.pricing.rent.period = 0
                  set.pricing.rent.timeUnit = null
                }
                if (vm.subscription.$periodType === 'DEFAULT') {
                  set.pricing.rent.period = vm.subscription.length
                  set.pricing.rent.timeUnit = vm.subscription.lengthType === 'Days' ? 'DAY' : 'MONTH'
                }
                if (vm.subscription.$periodType === 'UNLIMITED') {
                  set.pricing.rent.$periodType = 'DEFAULT'
                  set.pricing.rent.period = 0
                  set.pricing.rent.timeUnit = null
                }
              }
            })
          }
          vm.subscription.paidContentSets[type] = sets
          if (type !== 'multiSets') {
            vm.checkIntersection(type)
            vm.validateContentSetsQuantity()
          }
        },
        function dismiss () {
          angular.copy(initialSets, vm.subscription.paidContentSets[type]) // restore pricing
        })
  }

  /**
   * Create/Update pricing
   *
   * @memberof mwApp/packages.controller:SubscriptionContentSetsCtrl
   * @function
   * @param {String} type
   * @param {Object} addon
   * @param isViewMode
   */
  vm.editAddon = function (type, addon, isViewMode = false) {
    const initialSet = angular.copy(addon)
    $uibModal.open({
      templateUrl: 'components/packages/views/editAddon.html',
      controller: 'EditAddonCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        cs: function () {
          if (!addon.exclusivePaymentSystemSetting) {
            addon.exclusivePaymentSystemSetting = { assignedPaymentSystems: [] }
          }
          return addon
        },
        isViewMode: function () {
          return isViewMode
        },
        type: function () {
          return type
        },
        subscription: function () {
          return vm.subscription
        },
        networkId: function () {
          return pckg.id
        },
        allowedExclusivePaymentSystems: function () {
          return pckg.allowedExclusivePaymentSystems
        }
      }
    }).result
      .then(
        function close () {
          vm.checkIntersection(type)
          scope.getConditionItemsList() // @todo temporary for discounts
          vm.validateContentSetsQuantity()
        },
        function dismiss () {
          angular.copy(initialSet, addon)
        })
  }

  vm.openConflicts = function (item, type, addon = false) {
    event.stopPropagation()
    item.openConflict = true
    $uibModal.open({
      templateUrl: 'components/packages/popups/subscriptionContentSetsModal.html',
      controller: 'SubscriptionContentSetsModalCtrl as vm',
      windowClass: 'modal-class-conflict',
      animation: false,
      resolve: {
        item: function () {
          item.addon = addon
          return item
        },
        checkIntersection: function () {
          return () => vm.checkIntersection(type)
        }
      }
    })
      .result
      .then(
        function close () {

        },
        function dismiss () {
          item.openConflict = false
        })
  }

  vm.validateContentSetsQuantity = function () {
    return !Object.keys(CONTENT_SET_TYPES).some(type =>
      vm.subscription.freeContentSets[type].length || vm.subscription.paidContentSets[type].length)
  }

  vm.validateSection = isSectionInvalid

  vm.showLength = function (rent, type) {
    if (['channelSets', 'multiSets'].includes(type) && !rent.rentLengthOverride) {
      if (vm.subscription.$periodType === 'UNLIMITED') {
        return 'Unlimited'
      }
      if (vm.subscription.$periodType === 'DUE_DATE') {
        return `Until: ${dateAsUTC(vm.subscription.$dueDate, 'DD.MM.YYYY')}`
      }
      return vm.subscription.length + ' ' + (vm.subscription.lengthType === 'Days' ? 'Day(s)' : 'Month(s)')
    }
    if (rent.$periodType === 'DUE_DATE') {
      return `Until: ${dateAsUTC(rent.$dueDate, 'DD.MM.YYYY')}`
    }
    return rent.period + ' ' + (rent.timeUnit === 'DAY' ? 'Day(s)' : 'Month(s)')
  }

  vm.validateCcu = function (sets) {
    return sets?.some(cs => cs.numberOfCcu > (vm.subscription.$amountsCount || vm.subscription.deviceAmounts.length))
  }
}
